import {
  GET_USER_REPORT_FAILED,
  GET_USER_REPORT,
  GET_USER_REPORT_SUCCESS,
  FETCH_TRAINED_SENTENCE_COUNT_REPORT,
  FETCH_TRAINED_SENTENCE_COUNT_REPORT_SUCCESS,
  FETCH_TRAINED_SENTENCE_COUNT_REPORT_FAILED,
  FETCH_TRANSCRIPTED_SENTENCE_COUNT_REPORT,
  FETCH_TRANSCRIPTED_SENTENCE_COUNT_REPORT_SUCCESS,
  FETCH_TRANSCRIPTED_SENTENCE_COUNT_REPORT_FAILED,
  FETCH_COMPARED_STATISTIC_REPORT,
  FETCH_COMPARED_STATISTIC_REPORT_SUCCESS,
  FETCH_COMPARED_STATISTIC_REPORT_FAILED,
  FETCH_SPECIFIC_AUDIO,
  FETCH_SPECIFIC_AUDIO_SUCCESS,
  FETCH_SPECIFIC_AUDIO_FAILED,
  DOWNLOAD_HOURLY_REPORT,
  DOWNLOAD_HOURLY_REPORT_SUCCESS,
  DOWNLOAD_HOURLY_REPORT_FAILED,
  DOWNLOAD_RECORDING_PENDING_REPORT,
  DOWNLOAD_RECORDING_PENDING_REPORT_SUCCESS,
  DOWNLOAD_RECORDING_PENDING_REPORT_FAILED,
  DOWNLOAD_CSV_FILE,
  DOWNLOAD_CSV_FILE_SUCCESS,
  DOWNLOAD_CSV_FILE_FAILED,
  GET_TRANSCRIPT_LIST_TO_BE_RECORDED,
  GET_TRANSCRIPT_LIST_TO_BE_RECORDED_SUCCESS,
  GET_TRANSCRIPT_LIST_TO_BE_RECORDED_FAILED,
  LOGOUT,
  LOGOUT_SUCCESS,
  LOGUT_FAILED,
  API_URL,
  FETCH_AUDIT_USER_LIST,
  FETCH_AUDIT_USER_LIST_SUCCESS,
  FETCH_AUDIT_USER_LIST_FAILED,
} from "./../constants/constants";

import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import cookie from "react-cookies";

function* fetchUserReport(action) {
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/get-completed-report`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({ type: GET_USER_REPORT_SUCCESS, data: result.data });
  } catch (error) {
    yield put({ type: GET_USER_REPORT_FAILED, data: error });
  }
}

function* fetchTrainedCountReport(action) {
  const { startPage, endPage } = action.payload;
  const postData = {
    start_page: startPage,
    end_page: endPage,
  };
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/get-trained-sentence-count-report`, postData, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({
      type: FETCH_TRAINED_SENTENCE_COUNT_REPORT_SUCCESS,
      data: result.data,
    });
  } catch (error) {
    yield put({
      type: FETCH_TRAINED_SENTENCE_COUNT_REPORT_FAILED,
      data: error,
    });
  }
}

function* fetchTranscriptedReport(action) {
  const { startPage, endPage } = action.payload;
  const postData = {
    start_page: startPage,
    end_page: endPage,
  };
  try {
    const result = yield call(() =>
      axios.post(
        `${API_URL}/get-transcripted-sentence-count-report`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
    );
    yield put({
      type: FETCH_TRANSCRIPTED_SENTENCE_COUNT_REPORT_SUCCESS,
      data: result.data,
    });
  } catch (error) {
    yield put({
      type: FETCH_TRANSCRIPTED_SENTENCE_COUNT_REPORT_FAILED,
      data: error,
    });
  }
}

function* fetchComparedStatisticReport(action) {
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/get-compared-statistics-report`)
    );
    yield put({
      type: FETCH_COMPARED_STATISTIC_REPORT_SUCCESS,
      data: result.data,
    });
  } catch (error) {
    yield put({ type: FETCH_COMPARED_STATISTIC_REPORT_FAILED, data: error });
  }
}

// http://10.101.1.249:4040/get-specific-file?filename=33067188_kotak_eng_aud_1-in.wav
function* fetchSpecificFileName(action) {
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/get-specific-file?filename=${action.payload}`)
    );
    yield put({ type: FETCH_SPECIFIC_AUDIO_SUCCESS, data: result.data });
  } catch (error) {
    yield put({ type: FETCH_SPECIFIC_AUDIO_FAILED, data: error });
  }
}

function* fetchAuditUserList(action) {
  console.log(action.payload);
  // const { LoginId } = action.payload;
  const postData = {
    LoginId: action.payload,
  };
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/get-audit-user-list`, postData, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({
      type: FETCH_AUDIT_USER_LIST_SUCCESS,
      data: result.data,
    });
  } catch (error) {
    yield put({
      type: FETCH_AUDIT_USER_LIST_FAILED,
      data: error,
    });
  }
}

function* isLogoutSuccess(action) {
  try {
    const result = yield call(() => axios.get(`${API_URL}/logout`));
    yield put({ type: LOGOUT_SUCCESS, data: result.data });
  } catch (error) {
    yield put({ type: LOGUT_FAILED, data: error });
  }
}

function* getHourlyReport(action) {
  try {
    const result = yield call(() => axios.get(`${API_URL}/${action.payload}`));
    const a = document.createElement("a");
    document.body.appendChild(a);
    const url = result.data;
    a.href = result.data;
    const fileName = result.data.split("/");
    a.download = fileName[fileName.length - 1];
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
    yield put({ type: DOWNLOAD_HOURLY_REPORT_SUCCESS, data: result });
  } catch (error) {
    yield put({ type: DOWNLOAD_HOURLY_REPORT_FAILED, data: error });
  }
}

function* getCSVFile(action) {
  const { URL, start_date, end_date, flagValue, searchValue, REMOTE_ADDR } = action.payload;
  const userId = cookie.load("username");
  const Flag = flagValue;
  const ProductIds = searchValue;
  let postData = {};
  if (
    URL === "RPT-GET-RecordingDetails" ||
    URL === "RPT-GET-RecordingAuditDetails"
  ) {
    postData = {
      userId,
      start_date,
      end_date,
      ProductIds,
      Flag,
    };
  } else if (  URL === "RPT-GET-Translation-Audit-Details") {
    postData = {
      userId,
      start_date,
      end_date,
      REMOTE_ADDR
    }
  }
  else {
    postData = {
      userId,
      start_date,
      end_date
    };
  }
  try {
    const result = yield call(() => axios.post(`${API_URL}/${URL}`, postData));

    const a = document.createElement("a");
    document.body.appendChild(a);
    const url = result.data;
    a.href = result.data;
    const fileName = result.data.split("/");
    a.download = fileName[fileName.length - 1];
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
    yield put({ type: DOWNLOAD_CSV_FILE_SUCCESS, data: result });
  } catch (error) {
    yield put({ type: DOWNLOAD_CSV_FILE_FAILED, data: error });
  }
}

function* getRecordingPendingReport(action) {
  const userId = cookie.load("username");
  const postData = {
    userId,
  };
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/Userwise-Record-PendingCount`, postData)
    );
    const a = document.createElement("a");
    document.body.appendChild(a);
    const url = result.data;
    a.href = result.data;
    const fileName = result.data.split("/");
    a.download = fileName[fileName.length - 1];
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
    yield put({
      type: DOWNLOAD_RECORDING_PENDING_REPORT_SUCCESS,
      data: result,
    });
  } catch (error) {
    yield put({ type: DOWNLOAD_RECORDING_PENDING_REPORT_FAILED, data: error });
  }
}

function* getTranscriptTobeDownloaded(action) {
  const postData = {
    userId: action.payload.userid,
  };

  try {
    const result = yield call(() =>
      //axios.get(`${API_URL}/get-important-transcript?userId=${action.payload.userid}`)
      axios.post(`${API_URL}/get-important-transcript`, postData, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({
      type: GET_TRANSCRIPT_LIST_TO_BE_RECORDED_SUCCESS,
      data: result.data,
    });
  } catch (error) {
    yield put({ type: GET_TRANSCRIPT_LIST_TO_BE_RECORDED_FAILED, data: error });
  }
}

function* AdminDashBoard() {
  yield takeLatest(GET_USER_REPORT, fetchUserReport);
  yield takeLatest(
    FETCH_TRAINED_SENTENCE_COUNT_REPORT,
    fetchTrainedCountReport
  );
  yield takeLatest(
    FETCH_TRANSCRIPTED_SENTENCE_COUNT_REPORT,
    fetchTranscriptedReport
  );
  yield takeLatest(
    FETCH_COMPARED_STATISTIC_REPORT,
    fetchComparedStatisticReport
  );
  yield takeLatest(FETCH_SPECIFIC_AUDIO, fetchSpecificFileName);
  yield takeLatest(FETCH_AUDIT_USER_LIST, fetchAuditUserList);
  yield takeLatest(DOWNLOAD_HOURLY_REPORT, getHourlyReport);
  yield takeLatest(
    DOWNLOAD_RECORDING_PENDING_REPORT,
    getRecordingPendingReport
  );
  yield takeLatest(DOWNLOAD_CSV_FILE, getCSVFile);
  yield takeLatest(
    GET_TRANSCRIPT_LIST_TO_BE_RECORDED,
    getTranscriptTobeDownloaded
  );
  yield takeLatest(LOGOUT, isLogoutSuccess);
}

export default AdminDashBoard;
